import React from "react";
import ListTable from "../../../Components/Table/ListTable";
import ProfilesTableRow from "./ProfilesTableRow";
import { useTranslation } from "../../../context/Internationalization";

const schema = (t) => [
  {
    id: '',
    label: '',
    sortable: false,
    hideable: false,
    sx: { width: 64 },
  },
  {
    id: 'firstName',
    label: t('firstName'),
    sortable: false,
    sx: { minWidth: 180 },
  },
  {
    id: 'lastName',
    label: t('lastName'),
    sortable: false,
    sx: { minWidth: 180 },
  },
  {
    id: 'team',
    label: t('team'),
    sortable: false,
    sx: { minWidth: 180 },
  },
  {
    id: 'club',
    label: t('create_club'),
    sortable: false,
    sx: { minWidth: 180 },
  }
]

const ProfilesTable = ({ data = [], menuActions = [], lastElementRef, emptyMessage }) => {
  const { t } = useTranslation();
  const rowElement = (dato, index) => <ProfilesTableRow
      key={dato._id}
      lastElementRef={lastElementRef}
      data={dato}
      index={index}
      menuActions={menuActions}
  />

  return (
    <ListTable
      rows={data}
      columns={schema(t)}
      rowElement={rowElement}
      tableAriaLabel={t('profiles')}
      minWidth={784}
      emptyMessage={emptyMessage}
      tableSx={{
        '& > tbody > tr:nth-of-type(even)': { height: 'auto' },
      }}
    />
  );
};

export default ProfilesTable;
